import ola from '@/hooks/ola/ola_api.js';
import store from '@/store'

// 更新拨号状态
export function updateOlaState(key, value) {
    store.dispatch('setOlaState', {
        ...store.state.olaState,
        [key]: value
    })
}
// 获取拨号状态
export function getOlaState(key) {
    return store.state.olaState[key]
}

export function initOlaState() {
    store.dispatch('setOlaState', {
        olaReady: false,    // 是否已准备
        olaBusy: false,     // 是否占线,
        olaDisabled: false, // 是否不允许拨打
        olaStateStr: '',    // 状态显示文案
        olaSuccess: false,  // 是否接通成功
    })
}


export function ref(key) {
    return new RefImpl(key)
}

class RefImpl {
    constructor(key) {
        this.key = key
    }
    get value() {
        return getOlaState(this.key)
    }
    set value(newVal) {
        updateOlaState(this.key, newVal)
    }
}


// 是否已准备
const olaReady = ref('olaReady');
// 是否占线
const olaBusy = ref('olaBusy');
// 状态显示文案
const olaStateStr = ref('olaStateStr');
// 是否接通成功
const olaSuccess = ref('olaSuccess');

export class OlaServer {
    constructor(serIp, serPort, olaQueue, olaExtn, olaPassword) {
        // 服务器ip
        this.serIp = '';
        // 服务器端口
        this.serPort = '';
        // 队列
        this.olaQueue = '';
        // 分机
        this.olaExtn = '';
        // 分机密码
        this.olaPassword = '';
        // 是否已退出，初始化时需要先退出再登录
        this.exited = false;
        // 是否已登录
        this.logined = false;
        // 是否重新登录
        this.reLogin = false;
        // 重新登录记录
        this.rePhone = '';
        this.reOtherStr = '';
        // ws被中断
        this.breaked = false;
        // 心跳定时器
        this.pingTimer = null;
        this.serIp = serIp;
        this.serPort = serPort;
        this.olaQueue = olaQueue;
        this.olaExtn = olaExtn;
        this.olaPassword = olaPassword;
        this.init();
    }
    init() {
        initOlaState()
        const websocket_url = `wss://${this.serIp}:${this.serPort}/ola_socket`;
        ola.onConnect = this.connect.bind(this);
        ola.onClose = this.close.bind(this);
        ola.onMessage = this.message.bind(this);
        ola.connect(websocket_url, this.olaExtn, this.olaPassword);
    }
    // 连接
    connect() {
        ola._extn = this.olaExtn;
        ola.subscribe(`ola.agent.${this.olaExtn}`);
        ola.subscribe(`ola.caller.${this.olaExtn}`);
        ola.get_agent_state(this.olaExtn);
        this.login();
        this.logout();
        this.ping();
    }
    // 签入
    login() {
        ola.login([this.olaQueue], this.olaExtn, { type: 'onhook' });
    }
    // 签出
    logout() {
        ola.logout();
    }
    // 示闲
    ready() {
        ola.go_ready();
    }
    // 挂机
    hangup() {
        ola.hangup();
        olaStateStr.value = '';
    }
    // ws关闭回调
    close() {
        ola.unhold();
        this.breaked = true;
        this.logined = false;
        this.exited = false;
        this.end();
    }
    // 销毁
    destory() {
        ola.close();
        this.end();
        olaReady.value = false;
    }
    // 消息接收
    message(event) {
        const data = JSON.parse(event.data);
        if (data.event_type === 'agent_state') {
            // 分机状态
            if (data.state === 'login') {
                // 签入成功
                if (this.exited) {
                    this.logined = true;
                    this.ready();
                }
            }
            else if (data.state === 'ready') {
                // 示闲
                if (this.exited || this.breaked) {
                    this.breaked = false;
                    this.exited = true;
                    if (!olaReady.value)
                        olaReady.value = true;
                    if (this.reLogin) {
                        // 重新登录后立即重拨
                        this.reLogin = false;
                        this.dial(this.rePhone, this.reOtherStr);
                    }
                }
            }
            else if (data.state === 'logout') {
                // 签出
                if (!olaReady.value || this.breaked) {
                    this.breaked = false;
                    this.exited = true;
                    this.login();
                }
                else {
                    this.logined = false;
                    this.end();
                }
            }
            else if (data.state === 'busy') {
                olaBusy.value = true;
                if (data.private_data === 'calling') {
                    // 正在拨号
                    olaStateStr.value = '拨打中...';
                }
                else if (data.private_data === 'ring') {
                    // 话机振铃
                    // data.other_dn; 呼入的号码
                    // data.call_accept 话务流水（是通话记录表里的主键） //此处可open页面作为来电弹屏
                    olaStateStr.value = '振铃中...';
                }
                else if (data.private_data === 'answered') {
                    // 话机已接听
                    // 此处可open页面作为接听弹屏
                    olaStateStr.value = '语音通话中';
                    olaSuccess.value = true;
                }
            }
            else if (data.old_state === 'busy') {
                // 已挂机
                // 可扩展自动示闲
                this.end();
                this.ready();
            }
        }
    }
    // 通话结束
    end() {
        olaBusy.value = false;
        olaStateStr.value = '';
        olaSuccess.value = false;
    }
    // 拨打
    dial(phone, otherStr) {
        if (this.reLogin)
            return false;
        if (this.logined) {
            // 已登录
            ola.dial(phone.toString(), otherStr);
            olaBusy.value = true;
        }
        else {
            // 重新登录
            this.reLogin = true;
            this.rePhone = phone;
            this.reOtherStr = otherStr;
            if (this.breaked) {
                this.init();
            }
            else {
                this.login();
            }
        }
    }
    // 心跳
    ping() {
        if (this.breaked)
            return false;
        if (this.pingTimer)
            clearTimeout(this.pingTimer);
        this.pingTimer = setTimeout(() => {
            ola.ping();
        }, 55 * 1000);
    }
}
